// removed by extract-text-webpack-plugin
module.exports = {"marker":"LoadMap-marker","poiMarker":"LoadMap-poiMarker","loadedMarker":"LoadMap-loadedMarker","truckStopMarker":"LoadMap-truckStopMarker","weightStationMarker":"LoadMap-weightStationMarker","goodPoint":"LoadMap-goodPoint","badPoint":"LoadMap-badPoint","mediumPoint":"LoadMap-mediumPoint","pointHover":"LoadMap-pointHover","goodStatus":"LoadMap-goodStatus","mediumStatus":"LoadMap-mediumStatus","badStatus":"LoadMap-badStatus","markerInfo":"LoadMap-markerInfo","markerIcon":"LoadMap-markerIcon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadMap/index.css
// module id = 1712
// module chunks = 0